import { Modal, Typography } from "antd";

const { Title } = Typography;

export default function ContactAddList(props) {
    const { openList, setOpenList } = props;
    return (
        <Modal
            title={
                <Title level={3} className="modalTitle" strong>
                    Create New Contact List
                </Title>
            }
            open={openList}
            onCancel={() => setOpenList(false)}
            footer={null}
            width={500}
            centered
            className="contactListModal"
        >
            <div style={{ padding: 24, textAlign: 'center' }}>Feature coming soon</div>
        </Modal>
    );
}